import React from 'react';
import * as Constants from './constants';
import { sortByProp } from './utils';
import { LabeledSelectBox } from './LabeledSelectBox';

export const ManufacturerSelectBox = ({ manufacturers, selectedManufacturer, onManufacturerChanged }) => {
    if (!manufacturers) {
        return null;
    }

    manufacturers = sortByProp(manufacturers, "name")
        .filter(m => m.name);
    manufacturers.unshift(
        {
            name: Constants.PLACEHOLDER_MANUFACTURER,
            id: Constants.PLACEHOLDER_MANUFACTURER
        });

    return (
        <LabeledSelectBox
            items={manufacturers}
            selectedValue={selectedManufacturer || ""}
            onSelectionChanged={onManufacturerChanged}
            itemTextSelector={mfg => mfg.name}
            itemValueSelector={mfg => mfg.id}
        />
    )
}